<script setup lang="ts">
import { useVModel } from '@vueuse/core'

import { classMerge } from '../utils/class-merge'

import type { HTMLAttributes } from 'vue'

const props = defineProps<{
  // eslint-disable-next-line vue/no-reserved-props, vue/no-unused-properties
  class?: HTMLAttributes['class']
  defaultValue?: string | number
  modelValue?: string | number
}>()

// eslint-disable-next-line func-call-spacing
const emits = defineEmits<{
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  (e: 'update:modelValue', payload: string | number): void
}>()

// eslint-disable-next-line vue/no-setup-props-destructure
const modelValue = useVModel(props, 'modelValue', emits, {
  passive: true,
  defaultValue: props.defaultValue
})
</script>

<template>
  <textarea v-model="modelValue"
            :class="classMerge('flex min-h-40 w-full align-center border-2 border-aside bg-accent-secondary px-3.5 py-4 rounded-[4px] text-ui-md font-ui hover:border-action-hover focus:outline-none focus:ring focus:ring-ring focus:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50 aria-[invalid=true]:border-negative-foreground', props.class)" />
</template>
